import { Model, Attr } from 'spraypaint';
import Avatars from '@dicebear/avatars';
import sprites from '@dicebear/avatars-jdenticon-sprites';
import i18n from '@/plugins/vue-i18n';
import { isEqual } from 'lodash';
import ApplicationRecord from '../ApplicationRecord';

@Model()
export default class User extends ApplicationRecord {
  static jsonapiType = 'users';

  static async register(email: string, password: string) {
    const user = new User({ email, password });
    await user.save();
    return user;
  }

  static listHeaders() {
    return [
      {
        text: i18n.t('common.labels.id'),
        value: 'id',
        width: 70,
      },
      {
        text: i18n.t('common.labels.email'),
        value: 'email',
      },
      {
        text: i18n.t('users.labels.fullName'),
        value: 'fullName',
      },
    ];
  }

  static scopeFactory() {
    return User.includes([]);
  }

  @Attr() firstName: string;

  @Attr() lastName: string;

  @Attr() email: string;

  @Attr() totpStatus: 'pending' | 'verified' | null;

  @Attr() totpLoginAttempts: number;

  // write only
  @Attr() password: string;

  @Attr() currentPassword: string;

  @Attr() picture: string;

  @Attr() agreeTcAt: string;

  @Attr() tfaEnabled: boolean;

  @Attr() readonly geccoUserId: number;

  @Attr({ dirtyChecker: (a, b) => isEqual(a, b) }) roles: string[];

  changePassword(currentPassword: string, newPassword: string) {
    const user = new User({
      id: this.id,
      password: newPassword,
      currentPassword,
    });
    return user.save();
  }

  get avatar() {
    let avatar;
    if (this.picture) {
      avatar = this.picture;
    } else {
      const avatars = new Avatars(sprites, {
        dataUri: true,
        background: '#FFF',
      });
      avatar = avatars.create(`user${this.id}`);
    }
    return avatar;
  }

  get fullName() {
    const first = this.firstName || '';
    const last = this.lastName || '';
    if (first || last) {
      return `${first} ${last}`;
    }
    return this.email;
  }
}
